import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false;

export const openDialogRegisterSlice = createSlice({
 name: 'openDialogRegister',
 initialState,
 reducers: {
  openDialogRegister: (state, action: PayloadAction<boolean>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { openDialogRegister } = openDialogRegisterSlice.actions;

export default openDialogRegisterSlice.reducer;
